export default __webpack_public_path__ + "static/media/market2.3981a197.svg";